import { GrowDrawer } from "@sinecycle/growcomponents";
import React from "react";

function AntDrawer(props: React.ComponentProps<typeof GrowDrawer>) {
  return <GrowDrawer closable={false} {...props} />;
}

export { AntDrawer as Drawer };
